export function accordion() {
	document.addEventListener("DOMContentLoaded", function () {
		const accordions = document.querySelectorAll(
			".footer-accordion, .service-nav-accordion, .service-accordion, .home-4-accordion, .home-5-accordion, .contact-accordion"
		);
		const svgPanes = document.querySelectorAll(".home-5-image-pane");

		accordions.forEach((item) => {
			item.addEventListener("click", function (e) {
				if (e.target.tagName.toLowerCase() === "a") {
					return;
				}
				e.preventDefault();
				handleActive(this);
			});
		});

		function handleActive(currentAccordion) {
			const targetId = currentAccordion.getAttribute("data-target");
			const isHome5 = currentAccordion.classList.contains("home-5-accordion");

			const relatedAccordions = isHome5
				? document.querySelectorAll(".home-5-accordion")
				: accordions;

			relatedAccordions.forEach((accordion) => {
				if (accordion !== currentAccordion) {
					accordion.classList.remove("is-active");
					const content = accordion.querySelector(
						".footer-accordion-content, .service-accordion-content, .home-4-accordion-content, .home-5-accordion-content, .header-menu-accordion-content, .contact-accordion-content"
					);
					if (content) {
						$(content).slideUp();
					}

					if (isHome5) {
						const icon = accordion.querySelector(".home-5-accordion-icon");
						if (icon) {
							icon.classList.remove("rotate-180");
							icon.classList.add("rotate-0");
						}
					}
				}
			});

			currentAccordion.classList.toggle("is-active");

			if (isHome5) {
				const icon = currentAccordion.querySelector(".home-5-accordion-icon");
				if (icon) {
					if (currentAccordion.classList.contains("is-active")) {
						icon.classList.remove("rotate-0");
						icon.classList.add("rotate-180");
					} else {
						icon.classList.remove("rotate-180");
						icon.classList.add("rotate-0");
					}
				}
			}

			const content = currentAccordion.querySelector(
				".footer-accordion-content, .service-accordion-content, .home-4-accordion-content, .home-5-accordion-content, .header-menu-accordion-content, .contact-accordion-content"
			);
			if (content) {
				if (currentAccordion.classList.contains("is-active")) {
					$(content).slideDown();
				} else {
					$(content).slideUp();
				}
			}

			if (isHome5 && targetId) {
				svgPanes.forEach((pane) => pane.classList.remove("show"));
				const targetPane = document.querySelector(`#${targetId}`);
				if (targetPane) targetPane.classList.add("show");
			}
		}

		const firstHome5Accordion = document.querySelector(".home-5-accordion");
		if (firstHome5Accordion) handleActive(firstHome5Accordion);
	});
}

accordion();
